import _ from 'underscore';

import { getMovieMicrodata } from './movie';
import { getBreadcrumbsMicrodata } from './breadcrumbs';
import { getEventMicrodata } from './event';
import { getInstituteMicrodata } from './institute';

export const getMicrodata = (entity, entityType) => {
	let microdata = null;

	switch (entityType) {
		case 'broadcast':
		case 'movies':
			microdata = getMovieMicrodata(entity, entityType);
			break;
		case 'breadcrumbs':
			microdata = getBreadcrumbsMicrodata(entity);
			break;
		case 'institutes':
			microdata = getInstituteMicrodata(entity);
			break;
		case 'events':
			microdata = getEventMicrodata(entity);
			break;
		default:
			break;
	}

	return microdata;
};

export const addEntitiesMicrodata = (entities, entityType) =>
	_(entities).map((entity) => ({
		...entity,
		microdata: getMicrodata(entity, entityType)
	}));
